<template>
    <div class="wrap">
        <div class="head">
            <div class="info">
                <span>{{province}}</span> - <span>{{city}}</span>
            </div>
            <div class="search">
                <input type="text" placeholder="请输入医院关键字" v-model="keyword">
                <label>搜索</label>
            </div>
        </div>
        <div class="content">
            <div class="hospital-wrap">
                <div class="item" v-for="(value,index) in hospital" v-bind:key="index" @click="hospitalSelect(value)">
                    <label>{{value}}</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {ksdAddress} from "@/assets/js/api";

    export default {
        name: "RepToken",
        data(){
            return {
                province: this.$route.query.province,
                city:this.$route.query.city,
                hospital:[],
                keyword:"",
            }
        },
        methods:{
            toSubmit(){
                this.$router.push({path:"./repCode"})
            },
            async getAddress(province,city,condition){
                const res = await ksdAddress({province,city,condition})
                this.hospital = res.data.data
            },
            hospitalSelect(hospital){
                // console.log(hospital+" selected")
                localStorage.setItem("ksd_hospital",hospital)
                this.$router.go(-1)
            }
        },
        mounted(){
            this.getAddress(this.province,this.city,this.keyword)
        },
        watch:{
            keyword(){
                this.getAddress(this.province,this.city,this.keyword)
            }
        }
    }
</script>

<style scoped lang="scss">
    .wrap{
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-flow: column;
    }
    .head .info{
        background: #ddd;
        font-size: 18px;
        padding: 10px 3px;
    }
    .head .search{
        text-align: left;
        width: 100%;
        display: flex;
        margin: 10px 0;
        input{
            border: none;
            outline: none;
            flex-grow: 1;
            text-indent: 5px;
        }
        label{
            font-size: 18px;
            background: #2c9a58;
            margin: 0 10px 0 5px;
            padding: 5px 10px;
            border-radius: 3px;
            color: #FFF;

        }
    }
    .content{
        flex-grow: 1;
        overflow: scroll;
    }
    .content .hospital-wrap .item{
        font-size: 16px;
        text-align: left;
        border-bottom: 1px #999 solid;
        padding: 10px 0 0 5px;
        /*text-indent: 5px;*/
        /*padding-left: 5px;*/
    }
</style>